import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import Select from 'react-select';
import Download from '../MainSection/Download/Download';
import ManageOrdersTable from './ManageOrdersTable';
import AddManageOrders from './AddManageOrders';
import { useLocation, useNavigate } from 'react-router-dom';

const statusOptions = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In-Process", label: "In-Process" },
    { value: "Resolved", label: "Resolved" },
    { value: "Re-Open", label: "Re-Open" },
    { value: "Cancel", label: "Cancel" },
]
const ManageOrders = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [orders, setOrders] = useState([]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleAddOrder = (orderData) => {
        setOrders((prevOrders) => [orderData, ...prevOrders]);
    };

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state?.newOrder) {
            setOrders((prevOrders) => {
                // ✅ Check if the order already exists based on orderNumber
                const orderExists = prevOrders.some(order => order.orderNumber === location.state.newOrder.orderNumber);

                if (!orderExists) {
                    return [location.state.newOrder, ...prevOrders];
                }
                return prevOrders; // Do nothing if order already exists
            });

            // ✅ Clear state to avoid re-processing when navigating back
            navigate("/motor-builder", { replace: true, state: {} });
        }
    }, [location, navigate]);

    const handleAdd = () => {
        navigate('/motor-builder-add'); // Navigate to the Add page
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Manage Orders"
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Manage Orders</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <SbAddBtn btnName="Create Orders"
                                    // onClickEffect={handleOpenModal}
                                    onClickEffect={handleAdd}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <ManageOrdersTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                orders={orders}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {/* {
                isModalOpen && <AddManageOrders
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    onAddOrder={handleAddOrder}
                />
            } */}
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default ManageOrders;